import { TimeframeOption } from './adminDashboardTypes'
import { DashboardPeriod } from './dashboardTypes'

export const tripPeriodForTimeframe = (
  timeframe: TimeframeOption
): DashboardPeriod =>
  timeframe === '7d' ? 7 : timeframe === '90d' ? 90 : 30
